export default __webpack_public_path__ + "static/media/LWS-OG-logo.a0cc6950.png";